import React from 'react';
import {ButtonGroup, Button, makeStyles} from '@material-ui/core';
import useStore from '../../store/store';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginLeft: ({marginLeft}) => marginLeft,
    marginRight: 20,
    display: 'inline-block',
  },
  wrapperInDropdown: {
    float: 'left',
    left: 12,
    top: 7,
    position: 'relative',
  },
  button: {},
  buttonInDropDown: {
    fontSize: 12,
  },
}));

const DataTypeSelector = ({inDropdown, marginLeft = 20}) => {
  const setState = useStore(state => state.setState);
  const dataType = useStore(state => state.dataType);
  const classes = useStyles({marginLeft});

  return (
    <ButtonGroup
      size={inDropdown ? 'small' : 'medium'}
      class={inDropdown ? classes.wrapperInDropdown : classes.wrapper}
    >
      {['setupad', 'combined', 'publisher'].map(type => (
        <Button
          size="small"
          onClick={() => setState('dataType', type)}
          variant={dataType === type ? 'contained' : 'outlined'}
          color={dataType === type ? 'primary' : null}
          className={inDropdown ? classes.buttonInDropDown : classes.button}
        >
          {type}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default DataTypeSelector;
